import { useMemo } from 'react';

import { useAuth } from '@/contexts/AuthContext';
import { buildTerminology, type TerminologySet } from '@/config/terminology';

const CAMPUS_DEFAULTS: TerminologySet = Object.freeze({
  locationLabel: 'Campus',
  locationLabelPlural: 'Campuses',
  locationLabelAdd: 'Add Campus',
  locationLabelEdit: 'Edit Campus',
  locationLabelDelete: 'Delete Campus',
  locationLabelAll: 'All Campuses',
  locationLabelScope: 'Campus Scope',
  locationLabelCode: 'Campus Code',
  locationLabelDetails: 'Campus Details',
  locationSearchPlaceholder: 'Search campuses...',
  locationManageSubtitle: 'Manage your organization campuses',
});

/**
 * React hook that returns tenant-aware terminology labels.
 *
 * Reads `industry_code` and `primary_vertical_pack_code` from the
 * authenticated tenant context and resolves location labels accordingly.
 *
 * When auth tenant is null (pre-auth / setup wizard), returns Campus defaults.
 */
export function useTerminology(): TerminologySet {
  const { tenant } = useAuth();

  return useMemo(() => {
    if (!tenant) return CAMPUS_DEFAULTS;
    return buildTerminology({
      industryCode: tenant.industry_code,
      verticalPackCode: tenant.primary_vertical_pack_code,
    });
  }, [tenant?.industry_code, tenant?.primary_vertical_pack_code]);
}
